import { RouteV2Id } from 'routes/routesConfigV2';
import { QuoteChecklistCard } from 'types/enrollmentService';

export const QUOTE_CHECKLIST_MAPPING: Record<QuoteChecklistCard, RouteV2Id> = {
  [QuoteChecklistCard.INITIATE_SHELF]: RouteV2Id.QUOTE_PROPOSAL_INFO,
  [QuoteChecklistCard.INITIATE_SHELF_ADD_EMPLOYEES]: RouteV2Id.QUOTE_ADD_EMPLOYEES,
  [QuoteChecklistCard.IMQ_ADD_EMPLOYEES]: RouteV2Id.IMQ_ADD_EMPLOYEES,
  [QuoteChecklistCard.INITIATE_SHELF_ADD_QUOTE]: RouteV2Id.INITIATE_SHELF_ADD_QUOTE,
  /**
   * Temporary step used until the Add Quote page is implemented.
   * Once ready, the INITIATE_SHELF_ADD_QUOTE will be used in the flow instead of INITIATE_SHELF_BROWSING.
   */
  [QuoteChecklistCard.INITIATE_SHELF_BROWSING]: RouteV2Id.INITIATE_SHELF_BROWSING,
  [QuoteChecklistCard.ZYWAVE_QUOTE_REDIRECT]: RouteV2Id.ZYWAVE_QUOTE_REDIRECT,
  [QuoteChecklistCard.DOWNLOAD_IMQS]: RouteV2Id.DOWNLOAD_IMQS,
};
